import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'

import { get } from '../../components/settings'
import useTranslation from '../../../utils/translation'
import { Box, Details, StyledCheckBox } from './CancelStep2Shared'

const BoxStacked = styled(Box)`
  display: block;
  margin-top: 20px;
`

const FieldGroup = styled.div`
  margin-bottom: 20px;
`

const FieldLabel = styled.label`
  font-family: ${theme('typography.paragraph.fontFamily')};
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
`

const StyledSelect = styled.select`
  font-family: ${theme('typography.paragraph.fontFamily')};
  width: 100%;
  font-size: 16px;
  padding: 13px;
  border: 1px solid ${theme('forms.colors.border')};
  border-radius: 3px;
  background-color: ${theme('forms.colors.background')};
  appearance: none;

  &:focus {
    outline: none;
    border: 1px solid ${theme('forms.colors.activeBorder')};
    box-shadow: ${theme('colors.accentShadow')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const SelectWrapper = styled.div`
  position: relative;

  &::after {
    content: '';
    display: inline-block;
    pointer-events: none;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17 9.5L12 14.5L7 9.5' stroke='%23000000' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/svg%3E");
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
  }
`

const CancelStep2DesignerDeactivation = ({
  deactivateCustomer,
  onDeactivateCustomerChange,
  deactivationReason,
  onDeactivationReasonChange,
  deactivationTimeframe,
  onDeactivationTimeframeChange,
}) => {
  const t = useTranslation('cancel.step2')
  const reasonOptions = get('designerDeactivationReasons', [])
  const timeframeOptions = get('designerDeactivationTimeframes', [])

  if (!reasonOptions.length || !timeframeOptions.length) {
    return null
  }

  return (
    <BoxStacked>
      <Details cancellationReason="">
        <StyledCheckBox
          id="deactivate-customer"
          label={t('deactivate-customer')}
          checked={deactivateCustomer}
          onChange={onDeactivateCustomerChange}
          name="deactivate-customer"
        />
        <FieldGroup style={{ marginTop: '20px' }}>
          <FieldLabel htmlFor="deactivation-reason">
            {t('deactivation-reason')}
          </FieldLabel>
          <SelectWrapper>
            <StyledSelect
              id="deactivation-reason"
              value={deactivationReason}
              onChange={(e) => {
                if (e.target) {
                  onDeactivationReasonChange(e.target.value)
                }
              }}
              disabled={!deactivateCustomer}
            >
              {reasonOptions.map(({ value, label }) => (
                <option key={value || 'reason-placeholder'} value={value}>
                  {label}
                </option>
              ))}
            </StyledSelect>
          </SelectWrapper>
        </FieldGroup>
        <FieldGroup>
          <FieldLabel htmlFor="deactivation-timeframe">
            {t('deactivation-timeframe')}
          </FieldLabel>
          <SelectWrapper>
            <StyledSelect
              id="deactivation-timeframe"
              value={deactivationTimeframe}
              onChange={(e) => {
                if (e.target) {
                  onDeactivationTimeframeChange(e.target.value)
                }
              }}
              disabled={!deactivateCustomer}
            >
              {timeframeOptions.map(({ value, label }) => (
                <option key={value || 'timeframe-placeholder'} value={value}>
                  {label}
                </option>
              ))}
            </StyledSelect>
          </SelectWrapper>
        </FieldGroup>
      </Details>
    </BoxStacked>
  )
}

export default CancelStep2DesignerDeactivation
